import React, { createContext, useState } from "react";

export const GetStartedContext = createContext({
  isDrawerOpen: false,
  toggleDrawer: () => {},
});

export const GetStartedProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const value = {
    isDrawerOpen,
    toggleDrawer,
  };
  return (
    <GetStartedContext.Provider value={value}>
      {children}
    </GetStartedContext.Provider>
  );
};
